import { Navbar } from "./components/linkora/Navbar";
import { Hero } from "./components/linkora/Hero";
import { Marquee } from "./components/linkora/Marquee";
import { Services } from "./components/linkora/Services";
import { Portfolio } from "./components/linkora/Portfolio";
import { Diferenciais } from "./components/linkora/Diferenciais";
import { About } from "./components/linkora/About";
import { Process } from "./components/linkora/Process";
import { QuoteForm } from "./components/linkora/QuoteForm";
import { Footer } from "./components/linkora/Footer";
import { FloatingWhatsApp } from "./components/linkora/FloatingWhatsApp";

function App() {
    return (
        <div className="bg-[#0a0c10] text-[#f1f5f9] min-h-screen selection:bg-[#2563eb] selection:text-white antialiased overflow-x-hidden">
            <Navbar />
            <Hero />
            <Marquee />
            <Services />
            <Portfolio />
            <Diferenciais />
            <About />
            <Process />
            <QuoteForm />
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}

export default App;
